import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import { animated as a, useSpring } from 'react-spring';

import { Link } from 'gatsby';
import React from 'react';
import { LinkPhone, LinkOne } from '../../../_index';

const MenuDropDown = ({ isShown, setIsShown }) => {
  const expand = useSpring({
    width: '100%',

    opacity: isShown ? 1 : 0,
    marginTop: '-0px',
    height: isShown ? '20rem' : '0rem',
    config: {
      friction: 35,
    },
  });
  return (
    <a.div
      style={{ ...expand, overflow: 'hidden' }}
      onMouseLeave={() => setIsShown(false)}
      onMouseEnter={() => setIsShown(true)}
    >
      <Box
        boxShadow="lg"
        backgroundColor="white"
      >
        <Container
          display="flex"
          justifyContent="flex-end"
          backgroundColor="white"
          maxW="container.xl"
          height="100%"
          p={{ base: 2, md: 6 }}
          pt={10}
        >
          <Box
            p={4}
            borderRadius="lg"
            onClick={() => setIsShown(true)}
            _hover={{ backgroundColor: 'gray.100' }}
            flexBasis={{ base: '100%', md: '20%' }}
          >
            <Link
              style={{
                display: 'flex',
                height: '100%',
                justifyContent: 'space-between',
              }}
              to="/about"
            >
              <Box
                display="flex"
                height="100%"
                justifyContent="space-between"
                flexDir="column"
              >
                {/* <Box
                  mb={3}
                  mx="auto"
                  height="150px"
                >
                  <House1 className="width-100" />
                </Box> */}
                <Heading
                  as="h6"
                  size="md"
                >
                  About Us
                </Heading>
                <Text fontSize="lg">
                  Our Team of seasoned professionals are here to help
                  and available to answer your questions.
                </Text>
              </Box>
            </Link>
          </Box>
          <Box
            p={4}
            borderRadius="lg"
            _hover={{ backgroundColor: 'gray.100' }}
            onClick={() => setIsShown(true)}
            flexBasis={{ base: '100%', md: '20%' }}
          >
            <Link
              style={{
                display: 'flex',
                height: '100%',
                justifyContent: 'space-between',
              }}
              to="/blog"
            >
              <Box
                display="flex"
                justifyContent="space-between"
                flexDir="column"
              >
                {/* <Box
                  mb={3}
                  mx="auto"
                  height="150px"
                >
                  <House2 className="width-100" />
                </Box> */}
                <Heading
                  as="h6"
                  size="md"
                >
                  Blog
                </Heading>
                <Text fontSize="lg">
                  We have written a tone of articles with helpful
                  information on the selling process.
                </Text>
              </Box>
            </Link>
          </Box>
          <Box
            p={4}
            borderRadius="lg"
            onClick={() => setIsShown(true)}
            _hover={{ backgroundColor: 'gray.100' }}
            flexBasis={{ base: '100%', md: '20%' }}
          >
            <Link
              style={{
                display: 'flex',
                height: '100%',
                justifyContent: 'space-between',
              }}
              to="/faq"
            >
              <Box
                display="flex"
                height="100%"
                justifyContent="space-between"
                flexDir="column"
              >
                {/* <Box
                  mb={3}
                  mx="auto"
                  height="150px"
                >
                  <House3 className="width-100" />
                </Box> */}
                <Heading
                  as="h6"
                  size="md"
                >
                  FAQ
                </Heading>
                <Text fontSize="lg">
                  We put together the most frequently asked questions
                  to help you have a smooth home selling experiences.
                </Text>
              </Box>
            </Link>
          </Box>
          <Box
            p={2}
            borderRadius="lg"
            onClick={() => setIsShown(true)}
            _hover={{ backgroundColor: 'gray.100' }}
            flexBasis={{ base: '100%', md: '20%' }}
          >
            <Link
              style={{
                display: 'flex',
                height: '100%',
                justifyContent: 'space-between',
              }}
              to="/contact"
            >
              <Box
                display="flex"
                height="100%"
                justifyContent="space-between"
                flexDir="column"
              >
                {/* <Box mb={3} mx="auto">
                  <House4 className="width-100" />
                </Box> */}
                <Heading
                  as="h6"
                  size="md"
                >
                  Contact Us
                </Heading>
                <LinkPhone ml={4}>510.900.8770</LinkPhone>
                <Text fontSize="lg">
                  Have any questions or just want to learn more about
                  selling your home. We're here to help.
                  {' '}
                  <LinkOne
                    to="/contact"
                    fontSize="md"
                  >
                    Send us message
                    {' '}
                  </LinkOne>
                </Text>
              </Box>
            </Link>
          </Box>
        </Container>
      </Box>
    </a.div>
  );
};

export default MenuDropDown;
